import {
  CalendarDaysIcon,
  ClipboardListIcon,
  GiftIcon,
  MessageSquareTextIcon,
  Music2Icon,
  type LucideIcon,
} from 'lucide-react'

export type Bonus = {
  icon: LucideIcon
  title: string
  value: string
  description: string
  imageUrl: string
}

export const bonuses: Bonus[] = [
  {
    icon: Music2Icon,
    title: 'High-Performance Playlists',
    value: '$12 Value',
    description:
      '6 curated lists with specific BPM for every training phase: Flow, Power and Recovery. The right room energy without hunting for tracks.',
    imageUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/f905e6d2-8a26-48b4-9eb3-6ca0d1963154.jpg',
  },
  {
    icon: ClipboardListIcon,
    title: 'Elite Client Intake Forms',
    value: '$15 Value',
    description:
      'Professional health screening and consent templates, fully editable. Look established from the very first consultation.',
    imageUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/b9dd2262-36df-421c-8f50-dbe05ffab9be.jpg',
  },
  {
    icon: GiftIcon,
    title: 'The 3-Level Modification Guide',
    value: '$25 Value',
    description:
      'How to scale any exercise for Base, Standard or Pro levels instantly — so mixed-level groups stop slowing you down.',
    imageUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/52f121a5-e060-4d44-8ef7-6165cdb1cc2b.jpg',
  },
  {
    icon: CalendarDaysIcon,
    title: '12-Month Master Planner',
    value: '$20 Value',
    description:
      'A strategic calendar: know exactly which volume and which session you are coaching every week of the year.',
    imageUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/5bf1f49f-548a-48c1-892c-6703bc7016c3.jpg',
  },
  {
    icon: MessageSquareTextIcon,
    title: 'The "First Session" Conversion Script',
    value: '$15 Value',
    description:
      'The exact psychology and wording that turns a trial session into a long-term paying membership.',
    imageUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/a7a2aea5-d6f5-4f26-b478-176be5ed8406.jpg',
  },
]
